import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { Doughnut } from 'react-chartjs-2';
import { backgroundColorList } from "services/Utils";
import { borderColorList } from "services/Utils";


export default function FinanceiraConsorcio({ dados }) {
  return (
    <Card className="mt-4 dashboard-financeira-consorcio">
      <CardBody>
        <Row>
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
              <Doughnut
                data={{
                  labels: dados.itens.map(el => el.empresa),
                  datasets: [
                    {
                      data: dados.itens.map(el => el.percentualCota),
                      backgroundColor: dados.itens.map((_, i) => backgroundColorList[i]),
                      borderColor: dados.itens.map((_, i) => borderColorList[i]),
                      borderWidth: 1,
                    }
                  ]
                }}
                options={{
                  title: {
                    display: true,
                    text: "Distribuição Contratual"
                  },
                  legend: {
                    labels: false
                  },
                }}
              />
          </Col>
          <Col xs={12} lg={6}>
            <Doughnut
              data={{
                labels: dados.itens.map(el => el.empresa),
                datasets: [
                  {
                    data: dados.itens.map(el => el.percentualRecebido),
                    backgroundColor: dados.itens.map((_, i) => backgroundColorList[i]),
                    borderColor: dados.itens.map((_, i) => borderColorList[i]),
                    borderWidth: 1,
                  }
                ]
              }}
              options={{
                title: {
                  display: true,
                  text: "Distribuição Atual"
                },
                legend: {
                  labels: false
                },
                }}
              />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12}>
            <div className="dashboard-table-scroll">
              <Table className="align-items-center table-flush dashboard-wide-table">
                <thead>
                  <tr>
                    <th>Empresa</th>
                    <th className="text-right">Valor Distribuído</th>
                    <th className="text-right">% recebido</th>
                    <th className="text-right">% cota</th>
                    <th className="text-right">Diferença</th>
                  </tr>
                </thead>
                <tbody>
                  {dados.itens.map((el, i) => (
                    <tr key={el.id}>
                      <th style={{ display: "flex", flexDirection: 'row', gap: 10, alignItems: "center" }}>
                        <span style={{
                          display: "inline-block",
                          width: 24,
                          height: 24,
                          backgroundColor: backgroundColorList[i],
                          borderColor: borderColorList[i],
                          borderWidth: 1,
                          borderStyle: 'solid',
                          borderRadius: 12
                        }}></span>
                        {el.empresa}
                      </th>
                      <th className="text-right">R$ {el.valorDistribuidoFmt}</th>
                      <th className="text-right">{el.percentualRecebidoFmt}%</th>
                      <th className="text-right">{el.percentualCotaFmt}%</th>
                      <th className="text-right">{el.diferencaFmt}pp</th>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}
